import React, { memo } from 'react';
import { useSidebar } from '../context/SidebarContext';
import Sidebar from './Sidebar';

const SidebarComponent = memo(() => {
  const { collapsed, toggleCollapsed } = useSidebar();
  
  return (
    <Sidebar 
      collapsed={collapsed} 
      toggleCollapsed={toggleCollapsed} 
    />
  );
});

export default SidebarComponent;
